import { ResultModel } from 'data/result/result.model';
import { onPostResult, onGetResult, onGetResultByStudentId } from 'data/result/result.service';
import { useDispatch } from 'react-redux';
import resultSlice from 'redux/slice/result.slice';
import { notifyError, notifySuccess } from 'common/helper/notifications';
import decodeApiMessage from 'common/helper/decodeApiMessage';
import studentResultSlice from 'redux/slice/studentResult.slice';
import { FormInstance } from 'antd/lib/form';

export const useResult = () => {
  const dispatch = useDispatch();

  const publishResult = async (
    payload: ResultModel,
    form: FormInstance,
    onVisibleChange: any,
    onReload: any,
    setIsAddMarksClicked: any,
    setMarksState: any,
    setSelectedGrade: any,
    setSelectedSection: any,
  ) => {
    try {
      await onPostResult(payload).then(() => {
        form.resetFields();
        onVisibleChange(false);
        setIsAddMarksClicked(false);
        setMarksState([]);
        setSelectedGrade('');
        setSelectedSection('');
        onReload(true);
      });
      notifySuccess('Success', 'Result successfully published.');
      // fetchResult(payload.gradeId, payload.sectionId, payload.examYearId, payload.examTypeId);
    } catch (err) {
      onVisibleChange(true);

      onReload(false);
      notifyError('Error', decodeApiMessage(err));
    }
  };

  const fetchResult = async (
    gradeId: string,
    sectionId: string,
    examYearId: string,
    examTypeId: string,
  ) => {
    dispatch(resultSlice.actions.setLoading());
    try {
      const res = await onGetResult(gradeId, sectionId, examYearId, examTypeId);
      dispatch(resultSlice.actions.setData(res));
    } catch (err) {
      dispatch(resultSlice.actions.setError(err));
    }
  };
  const fetchResultByStudentId = async (studentId: string) => {
    dispatch(studentResultSlice.actions.setLoading());
    try {
      const res = await onGetResultByStudentId(studentId);
      dispatch(studentResultSlice.actions.setData(res));
    } catch (err) {
      dispatch(studentResultSlice.actions.setError(err));
    }
  };

  return { publishResult, fetchResult, fetchResultByStudentId };
};
